import axios from "axios";
import { API_URL } from "src/scenes/App";

export const PERMISSION_USER_GROUP = {
    EMPLOYEES: "employees",
    USER_LIST_CLIENTS: "user-list-clients",
    SALES_CLIENTS: "sales-clients"
} as const;

export type PermissionUserGroup = typeof PERMISSION_USER_GROUP[keyof typeof PERMISSION_USER_GROUP];

export async function getDefaultPermissions(
    userGroup: PermissionUserGroup, token: string, signal: AbortSignal
): Promise<number[] | null> {
    const response = await axios.get<{ permissionIds: number[] | null }>(
        `${API_URL}/permissions/defaults/${userGroup}`,
        { headers: { Authorization: `Bearer ${token}` }, signal }
    );
    return response.data.permissionIds;
}

export async function saveDefaultPermissions(
    userGroup: PermissionUserGroup, enabled: boolean, permissionIds: number[], employeeUuids: string[], token: string
): Promise<void> {
    await axios.put(`${API_URL}/permissions/defaults/${userGroup}`, {
        enabled, permissionIds, employeeUuids
    }, { headers: { Authorization: `Bearer ${token}` } });
}

export async function getPermissionsForUser(
    isClient: boolean, token: string, signal: AbortSignal
): Promise<Record<string, unknown[]>> {
    const response = await axios.get<{ permissions: Record<string, unknown[]> }>(
        `${API_URL}/permissions/${isClient ? "client" : "employee"}`,
        { headers: { Authorization: `Bearer ${token}` }, signal }
    );
    return response.data.permissions;
}
